import * as React from "react"
import styled, { css } from "styled-components"

import { Color, LineHeight, SpacingSize, TextSize, Transition } from "~/consts/style-mixins"

interface Props {
  children: string
  cutPoint: number
  size: "Medium" | "Small"
  className?: string
}

interface StyledProps {
  size: "Medium" | "Small"
}

const { useState } = React

const TextCut = ({ children, cutPoint, size, className }: Props) => {
  const [fullText, displayedFull] = useState(() => children.length <= cutPoint)

  return (
    <StyledTextCutWrapper className={className} size={size}>
      {fullText ? (
        children
      ) : (
        <div>
          {children.slice(0, cutPoint) + "..."}
          <StyledDisplayMore onClick={() => displayedFull(true)}>もっと見る</StyledDisplayMore>
        </div>
      )}
    </StyledTextCutWrapper>
  )
}

const StyledTextCutWrapper = styled.div`
  ${({ size }: StyledProps) => css`
    font-size: ${size === "Medium" ? TextSize.M : TextSize.S}px;
  `}
  line-height: ${LineHeight.L}%;
  white-space: pre-line;
`

const StyledDisplayMore = styled.span`
  font-weight: bold;
  color: ${Color.Secondary};
  ${Transition.Hover};
  &:hover {
    cursor: pointer;
    color: ${Color.SecondaryDark};
  }
`

export default TextCut
